import React, { useState, useEffect, useContext } from 'react';
import {
    FaUserShield, FaUser, FaEnvelope, FaKey, FaSave,
    FaExclamationTriangle, FaEye, FaEyeSlash, FaLock
} from 'react-icons/fa';
import api from '../../api/axios';
import { toast } from 'react-toastify';
import { AppContext } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';

const ManagerProfile = () => {
    const { user, getMe } = useContext(AppContext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
    });

    useEffect(() => {
        if (user) {
            setFormData(prev => ({
                ...prev,
                name: user.name || '',
                username: user.username || '',
                email: user.email || ''
            }));
        }
    }, [user]);

    const handleVerifySubmit = async (e) => {
        e.preventDefault();

        if (formData.password && formData.password !== formData.confirmPassword) {
            return toast.error("Konfirmasi password tidak cocok!");
        }

        setIsLoading(true);
        try {
            // 1. Simpan data ke server
            await api.patch('/auth/verify-credentials', formData);
            toast.success("Profil berhasil diperbarui!");

            // 2. Paksa browser memuat ulang halaman/state (menghindari error fungsi React)
            setTimeout(() => {
                if (user && !user.is_verified) {
                    window.location.href = '/manager/dashboard';
                } else {
                    window.location.reload();
                }
            }, 1000);

        } catch (error) {
            console.error("Update Error:", error);
            toast.error(error.response?.data?.msg || "Gagal memperbarui data.");
            setIsLoading(false); // Matikan loading HANYA jika gagal
        }
    };

    return (
        <div className="container-fluid p-0 animate-fade-in">
            <div className="row justify-content-center">
                <div className="col-lg-10 col-xl-8">

                    {/* PERINGATAN: Otomatis hilang jika is_verified sudah true */}
                    {user && (user.is_verified === false || user.is_verified === 0) && (
                        <div className="alert alert-warning border-0 shadow-sm rounded-4 mb-4 p-4 d-flex gap-3">
                            <FaExclamationTriangle className="fs-3 mt-1 flex-shrink-0 text-warning" />
                            <div>
                                <h6 className="fw-bold mb-1">Amankan Akun Anda!</h6>
                                <p className="small mb-0 opacity-75">
                                    Silakan lengkapi data profil Anda. <b>Catatan:</b> Username hanya dapat diubah <b>satu kali saja</b>.
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                        <div className="card-header bg-primary py-4 px-4 border-0">
                            <h5 className="text-white fw-bold m-0 d-flex align-items-center gap-2">
                                <FaUserShield /> Pengaturan Profil & Keamanan
                            </h5>
                        </div>
                        <div className="card-body p-4 p-md-5">
                            <form onSubmit={handleVerifySubmit}>

                                <div className="mb-4">
                                    <label className="form-label small fw-bold text-muted">Nama Lengkap Manajer</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-0"><FaUser className="text-muted" /></span>
                                        <input
                                            type="text"
                                            className="form-control bg-light border-0 py-2"
                                            required
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <div className="row g-4 mb-4">
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted d-flex justify-content-between">
                                            Username
                                            {(user?.username_changed === true || user?.username_changed === 1) &&
                                                <span className="badge bg-danger-subtle text-danger small"><FaLock size={10} /></span>
                                            }
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">@</span>
                                            <input
                                                type="text"
                                                className={`form-control border-0 py-2 ${(user?.username_changed === 1 || user?.username_changed === true)
                                                        ? 'bg-secondary-subtle text-muted cursor-not-allowed'
                                                        : 'bg-light'
                                                    }`}
                                                required
                                                readOnly={user?.username_changed === 1 || user?.username_changed === true}
                                                value={formData.username}
                                                onChange={(e) => {
                                                    if (!(user?.username_changed === 1 || user?.username_changed === true)) {
                                                        setFormData({ ...formData, username: e.target.value });
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">Email Korespondensi</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0"><FaEnvelope className="text-muted" /></span>
                                            <input
                                                type="email"
                                                className="form-control bg-light border-0 py-2"
                                                required
                                                value={formData.email}
                                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-3 bg-light rounded-4 mb-4 border border-info border-opacity-10">
                                    <h6 className="fw-bold small text-dark mb-3">Keamanan Kata Sandi</h6>
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">Password Baru</label>
                                            <div className="input-group shadow-sm rounded-3 overflow-hidden">
                                                <span className="input-group-text bg-white border-0"><FaKey className="text-muted" /></span>
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control border-0 py-2"
                                                    placeholder={user?.is_verified ? "Kosongkan jika tidak ingin ubah" : "Masukkan password baru"}
                                                    required={!user?.is_verified}
                                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                                />
                                                <button
                                                    type="button"
                                                    className="input-group-text bg-white border-0 text-muted"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">Konfirmasi Password</label>
                                            <div className="input-group shadow-sm rounded-3 overflow-hidden">
                                                <span className="input-group-text bg-white border-0"><FaKey className="text-muted" /></span>
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    className="form-control border-0 py-2"
                                                    required={formData.password !== ''}
                                                    placeholder="Ulangi password..."
                                                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                                                />
                                                <button
                                                    type="button"
                                                    className="input-group-text bg-white border-0 text-muted"
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                >
                                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end mt-5">
                                    <button
                                        type="submit"
                                        className="btn btn-primary px-5 py-3 rounded-pill fw-bold shadow-sm d-flex align-items-center gap-2 hover-scale"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <><div className="spinner-border spinner-border-sm"></div> Memproses...</>
                                        ) : (
                                            <><FaSave /> Simpan Perubahan Profil</>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .cursor-not-allowed { cursor: not-allowed !important; }
                .x-small { font-size: 0.75rem; }
            `}</style>
        </div>
    );
};

export default ManagerProfile;